<template>
  <b-modal id="project-creation-modal"
          @ok="handleCreate"
          ok-title='Create'
          header-class="pb-0"
          body-class="py-0"
          centered
          button-size="sm"
          header-bg-variant="secondary"
          body-bg-variant="secondary"
          footer-bg-variant="secondary"
          :key="activeProjectId">

    <template>
      <div>
        <b-form  @submit.stop.prevent>
          <label for="project-name-input" size="sm">Create a new project</label>
          <b-input @keydown.enter.native="handleCreate" v-model="projectName" :state="validation" id="project-name-input"></b-input>
          <b-form-invalid-feedback :state="validation">
            The project name must be 3-32 characters long.
          </b-form-invalid-feedback>
          <b-form-invalid-feedback :state="errorMessage === ''">
            {{errorMessage}}
          </b-form-invalid-feedback>
<!--          <div v-if="errorMessage !== ''" class="invalid-feedback">-->
<!--            {{errorMessage}}-->
<!--          </div>-->
        </b-form>
      </div>
    </template>

  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { ProjectCreationRequest } from '#/protobuf/service_account_pb';

export default {
  data() {
    return {
      projectName: '',
      errorMessage: '',
    };
  },
  computed: {
    ...mapGetters([
      'activeProjectId',
    ]),
    validation() {
      return (this.projectName.length > 2 && this.projectName.length < 32);
    },
  },
  methods: {
    handleCreate(bvModalEvt) {
      bvModalEvt.preventDefault();
      if (!this.validation) {
        console.warn('project creation validation failed');
        return;
      }
      this.createProject().then((response) => {
        console.log('created project', response);
        this.$nextTick(() => {
          this.projectName = '';
          this.$bvModal.hide('project-creation-modal');
        });
        this.$router.push({ path: '/home', query: { project: response.project.projectId } });
      }).catch((error) => {
        console.log('accounts/createNewProject error', error.message);
        this.errorMessage = error.message;
      });
    },
    createProject() {
      const request = new ProjectCreationRequest();
      request.setName(this.projectName);
      return this.$store.dispatch('accounts/createNewProject', request);
    },
  },
};
</script>
